module.exports = __webpack_public_path__ + "img/item-3.1f972b4.svg";